import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faStar as farStar } from '@fortawesome/free-regular-svg-icons';
import { faStar as fasStar } from '@fortawesome/free-solid-svg-icons';
import { FileType } from 'src/app/models/enums/file-type';
import { Attachment } from 'src/app/models/server/attachment';

@Component({
    selector: 'app-attachment',
    imports: [NgClass, FaIconComponent, MatTooltipModule, MatIconModule],
    templateUrl: './attachment.component.html',
    styleUrl: './attachment.component.scss'
})
export class AttachmentComponent {
    /**
     * Références des icônes utilisés dans le template.
     */
    public favorite = fasStar;
    public nonfavorite = farStar;

    /**
     * Références des Enums utilisées dans le template.
     */
    public FileType = FileType;

    /**
     * Valeur indiquant si le composant est affiché en mode consultation.
     */
    @Input()
    public readonly: boolean;

    /**
     * Pièce-jointe affiché par le composant.
     */
    @Input()
    public attachment: Attachment;

    /**
     * Valeur indiquant si la pièce-jointe est selectionnée.
     */
    @Input()
    public selected: boolean;

    /**
     * Emis lorsque l'utilisateur ajoute la pièce-jointe au favoris ou la retire des favoris.
     */
    @Output()
    public favoriteStateChanged: EventEmitter<Attachment> = new EventEmitter();

    /**
     * Emis lorsque l'utilisateur selectionne la pièce-jointe.
     */
    @Output()
    public attachmentSelected: EventEmitter<Attachment> = new EventEmitter();

    /**
     * Appelée lorsque l'utilisateur clique sur l'icone 'Ajouter aux favoris' ou 'Retirer des favoris'.
     * @param attachment Instance de la pièce-jointe.
     * @param state Valeur indiquant si la pièce-jointe doit être ajoutée aux favoris (true) ou bien retirer des favoris (false).
     */
    public onToggleFavorite(attachment: Attachment, state: boolean) {
        if (this.readonly == false) {
            attachment.isFavorite = state;
            this.favoriteStateChanged.next(attachment);
        }
    }

    /**
     * Appelée lorsque l'utilisateur clique sur la pièce-jointe.
     * @param attachment Instance de la pièce-jointe.
     */
    public onSelectFile(attachment: Attachment) {
        this.attachmentSelected.next(attachment);
    }

    /**
     * Retourne le type de fichier de la pièce-jointe.
     * @param attachment : Instance de la pièce-jointe.
     */
    public getFileType(attachment: Attachment): FileType {
        if (attachment.name.includes('.pdf')) {
            return FileType.PDf;
        } else if (attachment.name.includes('.txt')) {
            return FileType.Email;
        } else {
            return FileType.Unknown;
        }
    }
}
